// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-intranet-layout__navbar',
    // #endregion
    // #region Computes
    computed: {
        mainMenuEntriesLeft() {
            return this.$appHost.store.getter("navigation/getMenu", "INTRANET").filter(e => e.alignment == 0);
        },
        mainMenuEntriesRight() {
            return this.$appHost.store.getter("navigation/getMenu", "INTRANET").filter(e => e.alignment == 1);
        },
        currentUser() {
            return this.$appHost.store.get("session").currentUser;
        },
        userDisplayName() {
            return this.currentUser?.firstName ?? this.currentUser?.displayName;
        },
        hasPortalOptions() {
            return this.$appHost.portalVue.hasForTarget('menu-main__options');
        }
    },
    // #endregion
    // #region Methods
    methods: {
        getMenuItemCaption(menuItem) {
            if (menuItem.caption === '$UserName') {
                return this.$t('client.Common.Hello') + " " + this.userDisplayName;
            }
            else {
                return menuItem.caption;
            }
        }
    },
    // #endregion
});
// #endregion
